/**
 * stepNavigation.ts - Multi-step wizard navigation, validation, and
 * tab/badge state rendering.
 */
import { state } from './config';
import { syncStep2PlayerOptions } from './playerManagement';
import { renderStep3ReviewSummary } from './cart';

export function initStepNavigation(): void {
    document.querySelectorAll('.js-btn-next-step').forEach(btn => {
        btn.addEventListener('click', (e: Event) => {
            const target = e.currentTarget as HTMLElement;
            const targetStep = parseInt(target.getAttribute('data-target-step') || '1', 10);

            if (validateStep(state.currentStep)) {
                if (state.currentStep === 1 && targetStep === 2) {
                    syncStep2PlayerOptions();
                }
                if (targetStep === 3) {
                    renderStep3ReviewSummary();
                }
                goToStep(targetStep);
            }
        });
    });

    document.querySelectorAll('.js-btn-prev-step').forEach(btn => {
        btn.addEventListener('click', (e: Event) => {
            const target = e.currentTarget as HTMLElement;
            const targetStep = parseInt(target.getAttribute('data-target-step') || '1', 10);
            goToStep(targetStep);
        });
    });

    document.querySelectorAll('.js-step-indicator').forEach(tab => {
        tab.addEventListener('click', (e: Event) => {
            const target = e.currentTarget as HTMLElement;
            const targetStep = parseInt(target.getAttribute('data-step') || '1', 10);

            if (targetStep < state.currentStep || validateStep(state.currentStep)) {
                if (targetStep === 2) syncStep2PlayerOptions();
                if (targetStep === 3) renderStep3ReviewSummary();
                goToStep(targetStep);
            }
        });
    });
}

export function goToStep(stepNumber: number): void {
    state.currentStep = stepNumber;

    document.querySelectorAll('.step-content').forEach(panel => panel.classList.add('d-none'));
    const targetPanel = document.getElementById(`StepPanel${stepNumber}`);
    if (targetPanel) targetPanel.classList.remove('d-none');

    for (let i = 1; i <= 3; i++) {
        const tab = document.getElementById(`StepTab${i}`);
        if (!tab) continue;

        const badge = tab.querySelector('.badge');
        if (!badge) continue;

        if (i < stepNumber) {
            tab.className = 'nav-link fw-bold text-success js-step-indicator';
            tab.removeAttribute('disabled');
            badge.className = 'badge bg-success rounded-circle me-1';
        } else if (i === stepNumber) {
            tab.className = 'nav-link active fw-bold js-step-indicator';
            tab.removeAttribute('disabled');
            badge.className = 'badge bg-primary rounded-circle me-1';
        } else {
            tab.className = 'nav-link disabled fw-bold js-step-indicator';
            tab.setAttribute('disabled', 'true');
            badge.className = 'badge bg-secondary rounded-circle me-1';
        }
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function validateStep(stepNumber: number): boolean {
    const currentPanel = document.getElementById(`StepPanel${stepNumber}`);
    if (!currentPanel) return true;

    const inputs = currentPanel.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input[required], select[required]');
    let isValid = true;

    inputs.forEach(input => {
        if (!input.checkValidity()) {
            input.classList.add('is-invalid');
            isValid = false;
        } else {
            input.classList.remove('is-invalid');
        }
    });

    if (!isValid) {
        const firstInvalid = currentPanel.querySelector<HTMLElement>('.is-invalid');
        if (firstInvalid) firstInvalid.focus();
    }

    return isValid;
}